// extracted by mini-css-extract-plugin
export default {"card":"Ticket_card__TzKq5","image":"Ticket_image__7u9Xb","name":"Ticket_name__YSecN"};